
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronDoubleRightGoogle as ObiChevronDoubleRightGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-double-right-google.js';
 
 
 

 
 export const ObiChevronDoubleRightGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-double-right-google',
   elementClass: ObiChevronDoubleRightGoogleElement,
   events: {
     
   }
  });
 
 